export const CSEKK = 1;
export const ATUTALAS = 2;
export const CSOPORTOS_BESZEDES = 3;

export function getFizetesModByCodeFonev(fizmodKod) {
    if (!fizmodKod) return null;
    let fizmod = '';
    switch (fizmodKod) {
        case CSEKK: fizmod = 'csekk'; break;
        case ATUTALAS: fizmod = 'átutalás'; break;
        case CSOPORTOS_BESZEDES: fizmod = 'csoportos beszedés'; break;
        default:
            throw new Error('getFizetesModByCodeFonev fizmodKod not implemented yet');
    }
    return fizmod;
}
